/* eslint-disable import/prefer-default-export */
export const optionsMasterBrand = (t) => [
    {
        aclCode: 'header_master_brand',
        key: 'masterbrand',
        label: t('menu:Master_Brand'),
        notInAcl: true,
        children: [
            {
                aclCode: 'master_brand',
                key: 'brand',
                label: t('menu:Brand'),
                url: '/admin/catalog/masterbrand/brand',
                notInAcl: true,
            },
        ],
    },
];
